import { STORAGE_PREFIX, KEYS, buildSectionAnswersKey, buildAudioKey } from "../constants/storageKeys";
import { deleteIELTSExamDB, deleteMP3 } from "./indexedDB";

/**
 * Clear all examinax-prefixed keys from both localStorage and sessionStorage.
 */
export function clearPrefixedStorage() {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  });

  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith(STORAGE_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  });
}

/**
 * If the incoming uprId differs from the stored one, clear stale data.
 * Returns true if data was cleared.
 * Runs at module level before ExamProvider mounts.
 */
export function clearStaleExamData(currentUprId) {
  if (!currentUprId) return false;

  const storedUprId = localStorage.getItem(KEYS.CURRENT_EXAM_UPR_ID);

  console.log("storedUprId", storedUprId);
  console.log("currentUprId", currentUprId);

  let didClear = false;

  if (storedUprId && storedUprId !== currentUprId) {
    clearPrefixedStorage();
    didClear = true;
  }

  localStorage.setItem(KEYS.CURRENT_EXAM_UPR_ID, currentUprId);
  return didClear;
}

/**
 * Clear all exam data when an exam finishes or expires.
 * Async version that also clears IndexedDB.
 */
export async function clearFinishedExamData() {
  clearPrefixedStorage();
  await deleteIELTSExamDB();
}

/**
 * Clear answers for a specific section from both storages.
 */
export function clearSectionAnswers(section) {
  const key = buildSectionAnswersKey(section);
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

/**
 * Clear listening audio from IndexedDB for a given uprId.
 */
export async function clearListeningAudio(uprId) {
  await deleteMP3(buildAudioKey(uprId));
}

/**
 * Fire-and-forget IndexedDB cleanup.
 */
export function scheduleIndexedDBCleanup() {
  deleteIELTSExamDB().catch((err) =>
    console.error("Failed to clear IndexedDB:", err)
  );
}
